/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui
 * @description Navigation main menu
 * @section 4.5
 *
 */
import { createStyles, makeStyles } from "@material-ui/core/styles";
import React, { ReactNode } from "react";
const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      flex: 1,
    },
    content: {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "7px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
        borderRadius: "3px",
      },
      scrollbarColor: "#888 #f1f1f1",
      scrollbarWidth: "thin",
    },
  })
);
interface VerticalScrollProps {
  children: ReactNode;
  containerClassName?: string;
  contentClassName?: string;
}
const VerticalScroll = ({
  children,
  contentClassName = "",
  containerClassName = "",
}: VerticalScrollProps) => {
  const classes = useStyles();
  return (
    <div
      className={
        containerClassName !== ""
          ? `${classes.container} ${containerClassName}`
          : classes.container
      }
    >
      <div
        className={
          contentClassName !== ""
            ? `${classes.content} ${contentClassName}`
            : classes.content
        }
      >
        {children}
      </div>
    </div>
  );
};
export default VerticalScroll;
